/**
 * Faceta «Configurações» — o ⌘K lendo o catálogo do hub (T13 do plano de agosto, fechada
 * em 30/Set/2026 pela D5). Computação LOCAL sobre `searchCatalog` (label + sinônimos, acento
 * dobrado) — zero request, como `use-screen-hits`.
 *
 * Só entra item com a capability CONCEDIDA e sem `soon` — mesma regra do silêncio da faceta
 * de telas: destino inalcançável é pior que resultado a menos. `omitWhenBarred` cai na mesma
 * peneira (sem a cap, não existe).
 *
 * O `meta` carrega a NATUREZA («Seção · IA & conduta» / «Ferramenta · IA & conduta») — é o
 * que evita a surpresa: seção aterrissa numa âncora e salva na barra; ferramenta abre página
 * própria (prancha 03/3a). Ordenar por relevância entre naturezas é limite declarado da
 * prancha: aqui vale a ordem do catálogo.
 */
import { useMemo } from 'react';

import { useCapabilities } from '../../hooks/use-capability';
import { catalogTarget, DOMINIOS, searchCatalog } from '../admin/hub/catalog';

import type { SpotlightItem } from './types';

export function useConfigHits(term: string): SpotlightItem[] {
  const capabilities = useCapabilities();
  return useMemo(() => {
    const out: SpotlightItem[] = [];
    for (const item of searchCatalog(term)) {
      if (item.soon === true) continue;
      if (!capabilities.includes(item.capability)) continue;
      const dominio = DOMINIOS.find((d) => d.id === item.dominio)!;
      out.push({
        key: `config:${item.id}`,
        section: 'config',
        label: item.label,
        meta: `${item.natureza === 'ferramenta' ? 'Ferramenta' : 'Seção'} · ${dominio.label}`,
        to: catalogTarget(item),
      });
    }
    return out;
  }, [capabilities, term]);
}
